import { createPortal } from "react-dom";
import { ClassificationLabels } from "../../../../models/classification.map";
import { patientDisplayName } from "../../model/commandeListFormat";
import { productDestination } from "../../model/commandeListAppearance";
import { useSummaryPopover } from "../../hooks/useSummaryPopover";

function AssignmentProducts({ medicaments }) {
    if ((medicaments ?? []).length === 0) {
        return <div className="commande-count-details-empty">Aucun produit assigné</div>;
    }
    return (
        <div className="commande-count-details-products">
            {medicaments.map((product, productIndex) => {
                const { key: destination, label: destinationLabel } = productDestination(product);
                return (
                    <div
                        className={`commande-count-details-product commande-count-details-product--${destination}`}
                        key={product.id ?? `${product.nom}-${productIndex}`}
                    >
                        <span>{product.nom || "Produit sans nom"}</span>
                        <small>{destinationLabel}</small>
                    </div>
                );
            })}
        </div>
    );
}

function CommandeAssignmentDetails({ patients }) {
    return (
        <>
            <div className="commande-count-details-title">Patients et produits de la commande</div>
            {patients.length === 0 ? (
                <div className="commande-count-details-empty">Aucun patient</div>
            ) : patients.map((patient, index) => (
                <div className="commande-count-details-assignment" key={patient.commandePatientId ?? index}>
                    <div className="commande-count-details-patient-heading">
                        <strong>{patientDisplayName(patient)}</strong>
                        {patient.classification && patient.classification !== "-" && (
                            <span>{ClassificationLabels[patient.classification] ?? patient.classification}</span>
                        )}
                    </div>
                    <AssignmentProducts medicaments={patient.medicaments} />
                </div>
            ))}
        </>
    );
}

// Zone des compteurs d'une ligne : affiche au survol le détail des patients et produits de la commande.
export function CommandeSummaryPopover({ patients, children }) {
    const { open, position, anchorRef, show, scheduleClose, cancelClose, toggle, hide } = useSummaryPopover();

    const details = open && position && typeof document !== "undefined" ? createPortal(
        <div
            role="tooltip"
            className="commande-count-details"
            style={position}
            onMouseEnter={cancelClose}
            onMouseLeave={scheduleClose}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => event.stopPropagation()}
            tabIndex={-1}
        >
            <CommandeAssignmentDetails patients={patients} />
        </div>,
        document.body
    ) : null;

    return (
        <div
            ref={anchorRef}
            className="commande-counts-popover"
            tabIndex={0}
            aria-label="Afficher les patients et les produits de la commande"
            aria-expanded={open}
            onMouseEnter={show}
            onMouseLeave={scheduleClose}
            onFocus={show}
            onBlur={scheduleClose}
            onClick={event => {
                event.stopPropagation();
                toggle();
            }}
            onKeyDown={event => {
                if (event.key === "Escape") hide();
            }}
        >
            {children}
            {details}
        </div>
    );
}
